import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import { getSessionAccount } from '../store/session/selectors';
import { HOME_PATH } from './paths';

const GuestOnlyRoute: FC = () => {
    const isAuthenticated = !!useSelector(getSessionAccount);

    return isAuthenticated ? <Navigate to={HOME_PATH} replace /> : <Outlet />;
};

export default GuestOnlyRoute;
